/** Each guide body as its own chunk, by slug (see registry.js). */
export const GUIDE_BODY_LOADERS = {
  'airline-fare-hold-policies': () => import('./airline-fare-hold-policies.js'),
  'airlines-that-offer-buy-now-pay-later': () => import('./airlines-that-offer-buy-now-pay-later.js'),
  'basic-economy-real-cost': () => import('./basic-economy-real-cost.js'),
  'biggest-travel-sites-slowest-flight-search': () => import('./biggest-travel-sites-slowest-flight-search.js'),
  'book-flights-with-bad-credit': () => import('./book-flights-with-bad-credit.js'),
  'book-flights-without-klarna-or-affirm': () => import('./book-flights-without-klarna-or-affirm.js'),
  'cheapest-day-to-fly': () => import('./cheapest-day-to-fly.js'),
  'do-cheap-flight-sites-have-cheaper-fares': () => import('./do-cheap-flight-sites-have-cheaper-fares.js'),
  'does-buy-now-pay-later-affect-credit-score': () => import('./does-buy-now-pay-later-affect-credit-score.js'),
  'flight-loans-vs-payment-plans': () => import('./flight-loans-vs-payment-plans.js'),
  'flight-payment-plans-no-credit-check': () => import('./flight-payment-plans-no-credit-check.js'),
  'holiday-flights-pay-over-time': () => import('./holiday-flights-pay-over-time.js'),
  'how-to-save-for-a-trip': () => import('./how-to-save-for-a-trip.js'),
  'international-flights-payment-plan': () => import('./international-flights-payment-plan.js'),
  'is-fly-now-pay-later-legit': () => import('./is-fly-now-pay-later-legit.js'),
  'missed-pay-later-payment-on-a-flight': () => import('./missed-pay-later-payment-on-a-flight.js'),
  'pay-for-flights-with-debit-card': () => import('./pay-for-flights-with-debit-card.js'),
  'pay-monthly-for-flights': () => import('./pay-monthly-for-flights.js'),
  'student-flights-no-credit-history': () => import('./student-flights-no-credit-history.js'),
  'when-to-book-flights-fare-data': () => import('./when-to-book-flights-fare-data.js'),
};
